import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const invoiceApi = createApi({
    reducerPath: "invoiceApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["Invoice"],
    endpoints: (builder) => ({
        getAllInvoices: builder.query({
            query: ({ pageno, search, status, role ,sortOrder , sortBy ,partialOrUnpaid, limit}) => {
                let url = `/${role}/invoices?pageno=${pageno}`;
                if (search) {
                    url += `&search=${search}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }
                if(sortOrder){
                        url += `&sortOrder=${sortOrder}`
                }
                if(sortBy){
                    url += `&sortBy=${sortBy}`
                }
                if(partialOrUnpaid){
                    url += `&partialOrUnpaid=${partialOrUnpaid}`
                }
                if(limit){
                    url += `&limit=${limit}`
                }
                return {
                    url,
                    method: "GET",
                };
            },
            providesTags: ["Invoice"],
        }),
        getInvoiceById: builder.query({
            query: ({ id, role }) => ({
                url: `/${role}/invoice/${id}`,
                method: "GET",
            }),
            providesTags: ["Invoice"],
            transformResponse: (response) => response?.body,
        }),
        addInvoice: builder.mutation({
            query: (data) => ({
                url: `/contractor/invoices`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Invoice"],
        }),
        updateInvoice: builder.mutation({
            query: ({ id, data }) => ({
                url: `/contractor/invoices/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Invoice"],
        }),
        deleteInvoice: builder.mutation({
            query: (id) => ({
                url: `/contractor/invoices/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Invoice"],
        }),
        downloadInvoice: builder.query({
            query: ({ id }) => ({
                url: `/contractor/invoice/${id}/pdf`,
                method: "GET",
            })
        }),
        markInvoiceAsPaid: builder.mutation({   
            query: ({ id }) => ({
                url: `/contractor/invoice/${id}/mark_paid`,
                method: "PUT",
            }),
            invalidatesTags: ["Invoice"],
        }),
        sendEmailInvoice: builder.mutation({
            query: ({ id }) => ({
                url: `/contractor/invoice/${id}/email`,
                method: "POST",
        }),
        invalidatesTags: ["Invoice"],
       }),
        getInvoiceByToken: builder.query({
            query: (token) => ({
                url: `/contractor/invoice/pay/info?token=${token}`,
                method: "GET",
            }),
            providesTags: ["Invoice"],
            transformResponse: (response) => response?.body,
        }),
    }),
});

export const {
    useGetAllInvoicesQuery,
    useAddInvoiceMutation,
    useUpdateInvoiceMutation,
    useDeleteInvoiceMutation,
    useGetInvoiceByIdQuery,
    useLazyDownloadInvoiceQuery,
    useMarkInvoiceAsPaidMutation,
    useSendEmailInvoiceMutation,   
    useGetInvoiceByTokenQuery,     
} = invoiceApi;
